import logo from '../assets/logo.png';
import resume from "../assets/Resume-Anjali_Kumari_Dubey.pdf"

export default function Navbar() {
    return (
        <div className='fixed z-50 w-full top-0 left-0 px-8 py-4 lg:px-20 xl:px-36' style={{
            backgroundColor: "rgb(26, 25, 25)"
        }}>
            <div className="flex justify-between items-center text-white">
                <img src={logo} style={{ width: "8rem" }} className="App-logo rounded-full" alt="logo" />
                <ul className="hidden md:flex">
                    <li className="p-4"><a href="#home" className="hover:underline">About</a></li>
                    <li className="p-4"><a href="#skills" className="hover:underline">Skills</a></li>
                    <li className="p-4"><a href="#projects" className="hover:underline">Projects</a></li>
                    <li className="p-4"><a href="#certificates" className="hover:underline">Certficates</a></li>
                    <li className="p-4"><a href="#education" className="hover:underline">Education</a></li>
                    <li className="p-4"><a href="#contact" className="hover:underline">Contact</a></li>
                </ul>
                <a href={resume} rel="noreferrer" target="_blank" style={{ backgroundColor: "#4b2d65", border: "4px #ffe9ff solid" }} className=" rounded-full px-4 py-1 border">Resume</a>
            </div>
        </div>
    )
}
